module.exports = __webpack_public_path__ + "static/media/car2.8c1ded8d.png";